module.exports = __webpack_public_path__ + "static/media/upload-icon.e9a76c89.svg";